export const CUSTOMER_DETAILS_UPDATED = 'CUSTOMER_DETAILS_UPDATED';
export const CUSTOMER_DETAILS_SAVED = 'CUSTOMER_DETAILS_SAVED';
export const CUSTOMER_DETAILS_READY = 'CUSTOMER_DETAILS_READY';

export function customerDetailsUpdated(details) {
  return {
    type: CUSTOMER_DETAILS_UPDATED,
    details,
  };
}

export function customerDetailsSaved(values) {
  return {
    type: CUSTOMER_DETAILS_SAVED,
    values,
  };
}

export function customerDetailsDataReady(details) {
  return {
    type: CUSTOMER_DETAILS_READY,
    details,
  };
}



// WEBPACK FOOTER //
// ./src/services/DataServices/CustomerDetailsService/actions.js